
export default function ToggleSwitch({ darkMode, toggleDarkMode }) {
  return (
    <label className='switch'>
      <input type='checkbox' onClick={toggleDarkMode} defaultChecked={darkMode} />
      <span className={`slider cursor-pointer`} />
    </label>
  )
}
